import {
  svgRectToOverlayPct,
  type OverlaySpriteTarget,
} from './modifierOverlayCoords';

/** Play strip height from Faktor Plant.svg. */
export const FACTOR_OVERLAY_PLAY_H = 929.588;

export type FactorOverlayPath = OverlaySpriteTarget & {
  id: string;
  srcKey: 'factor_1' | 'factor_2';
  startXPct: number;
  startYPct: number;
  finishXPct: number;
  finishYPct: number;
  staggerSec: number;
};

function pathToOverlay(
  id: string,
  srcKey: FactorOverlayPath['srcKey'],
  startSvgX: number,
  startSvgY: number,
  finishSvgX: number,
  finishSvgY: number,
  widthSvg: number,
  heightSvg: number,
  staggerIndex: number,
): FactorOverlayPath {
  const start = svgRectToOverlayPct(
    startSvgX,
    startSvgY,
    widthSvg,
    heightSvg,
    FACTOR_OVERLAY_PLAY_H,
  );
  const finish = svgRectToOverlayPct(
    finishSvgX,
    finishSvgY,
    widthSvg,
    heightSvg,
    FACTOR_OVERLAY_PLAY_H,
  );
  return {
    id,
    srcKey,
    ...start,
    startXPct: start.xPct,
    startYPct: start.yPct,
    finishXPct: finish.xPct,
    finishYPct: finish.yPct,
    staggerSec: staggerIndex * 0.25,
  };
}

/** From Faktor Plant.svg mirage paths. */
export const FACTOR_OVERLAY_PATHS: readonly FactorOverlayPath[] = [
  pathToOverlay(
    'factor_mirage_1',
    'factor_1',
    6850.68,
    875.37,
    6320.68,
    875.37,
    2774,
    306,
    0,
  ),
  pathToOverlay(
    'factor_mirage_2',
    'factor_2',
    7041.76,
    164.71,
    6511.76,
    164.71,
    2384,
    415,
    1,
  ),
] as const;
